import WatchAppointmentList from '@/components/watch/appointments/AppointmentList'
import WatchAppointmentCalendar from '@/components/watch/appointments/AppointmentCalendar'
import WatchAppointmentDayView from '@/components/watch/appointments/AppointmentDayView'

export default [
	{
		path: 'appointments',
		redirect: 'appointments/upcoming',
		name: 'WatchAppointments'
	},
	{
		path: 'appointments/all',
		name: 'WatchAppointmentAll',
		component: WatchAppointmentList,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile
		})
	},
	{
		path: 'appointments/upcoming',
		name: 'WatchAppointmentUpcoming',
		component: WatchAppointmentList,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile
		})
	},
	{
		path: 'appointments/calendar/month',
		name: 'WatchAppointmentCalendar',
		component: WatchAppointmentCalendar,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile
		})
	},
	{
		path: 'appointments/calendar/day',
		name: 'WatchAppointmentDayView',
		component: WatchAppointmentDayView,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile
		})
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch/appointments.js